/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  flex-flow: column;
`;

export const SelectedMain = styled.div`
  padding: 0;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  border-top: 0;
  border-right: 0;
  border-bottom: 1;
  background-color: ${Palette.PrimaryGray._100};
  height: 389px;
  overflow: hidden;
`;

export const Selected = styled.div``;
